var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "uploaded" } },
    [
      _c("h2", [_vm._v("アップロードが完了しました")]),
      _vm._v(" "),
      this.$route.query.msg
        ? _c("p", { staticClass: "has-text-danger" }, [
            _vm._v(_vm._s(this.$route.query.msg))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm._l(this.$store.state.uploadedFilesName, function(file) {
        return _c("div", { key: file.id, staticClass: "list" }, [
          _c("div", { staticClass: "list-item" }, [
            file.extension === "png" ||
            file.extension === "jpg" ||
            file.extension === "jpeg" ||
            file.extension === "gif"
              ? _c("img", {
                  staticStyle: { width: "200px" },
                  attrs: {
                    src: _vm.baseURL + "/upload/" + file.name + "?show=true"
                  }
                })
              : _c("img", {
                  staticStyle: { width: "200px" },
                  attrs: { src: "/static/images/document.svg" }
                }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(file.name))])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "copy" }, [
            _vm.isCopied
              ? _c("p", { staticClass: "has-text-info" }, [
                  _vm._v("URLをコピーしました")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: {
                  click: function($event) {
                    _vm.exec(
                      "https://files-uploader.xzy.pw/upload/" + file.name
                    )
                  }
                }
              },
              [_vm._v("URLをコピー\n      ")]
            )
          ])
        ])
      }),
      _vm._v(" "),
      _c("modal", { attrs: { name: "buymeacoffee", adaptive: "" } }, [
        _c("div", { staticClass: "buymeacoffee has-text-centered" }, [
          _c("h2", [_vm._v("運営維持のためにコーヒーを私に...")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("link", {
            attrs: {
              href: "https://fonts.googleapis.com/css?family=Cookie",
              rel: "stylesheet"
            }
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "bmc-button",
              attrs: {
                target: "_blank",
                href: "https://www.buymeacoffee.com/zTUrf4e"
              }
            },
            [
              _c("img", {
                attrs: {
                  src:
                    "https://www.buymeacoffee.com/assets/img/BMC-btn-logo.svg",
                  alt: "Buy me a coffee"
                }
              }),
              _c("span", { staticStyle: { "margin-left": "5px" } }, [
                _vm._v("Buy me a coffee")
              ])
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-success",
              on: {
                click: function($event) {
                  _vm.$modal.hide("buymeacoffee")
                }
              }
            },
            [_vm._v("Close")]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e0ae2e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0ae2e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uploaded.vue
// module id = null
// module chunks = 